import { FC } from "react";
import AnimateHeight from "../AnimateHeight";
import Modal from "../Modal";
import ThemeWrapper from "../ThemeWrapper";
import TrialSocialProofColumn from "./TrialSocialProofColumn";

type TrialModalContainerProps = {
  name: string;
  preventClose: boolean;
  onClose: () => void;
  backgroundImageSrc: string;
  children: React.ReactNode;
}

export const TrialModalContainer: FC<TrialModalContainerProps> = ({ name, preventClose, onClose, backgroundImageSrc, children }) => {
  return (

    <Modal
      className='max-w-3xl p-0 flex overflow-visible'
      buttonTheme="theme-gray"
      name={name}
      preventClose={preventClose}
      sendEvents={!preventClose}
      backgroundImageSrc={backgroundImageSrc}
      onClose={() => {
        onClose();
      }}>
      <div className="grid md:grid-cols-2">
        <TrialSocialProofColumn />
        <ThemeWrapper theme="theme-white" className="flex flex-col justify-center items-center">
          <AnimateHeight>
            <div className="my-auto flex flex-col gap-y-md p-lg">
              {children}
            </div>
          </AnimateHeight>
        </ThemeWrapper>
      </div>
    </Modal>
  )
}
